import { D } from '@mobily/ts-belt';
import { global_seo_data } from '../../utils/requests/contentstack/contentStackZodSchema';
import type { SEODataProps } from './SEOData';
import { getCloudinarySourceUrl } from '../../utils/getCloudinaryItem/getCloudinaryItem';
import type { JsonLdSchema } from '../JsonLd/JsonLd';
const contentstackJsonLdToJsonLdData = (value: Record<string, unknown>): JsonLdSchema | null => {
  if (D.isEmpty(value)) return null;
  return value as JsonLdSchema;
};
const contentstackJsonLdListToJsonLdData = (items: {
  entity: Record<string, unknown>;
}[]): JsonLdSchema[] => {
  return items.map(item => contentstackJsonLdToJsonLdData(item.entity)).filter((item): item is JsonLdSchema => item !== null);
};
export const seoDataSchema = global_seo_data.transform<SEODataProps>(data => ({
  bingValidation: data.bing_validation,
  canonicalUrl: data.canonical_url,
  description: data.meta_description,
  googleValidation: data.google_validation,
  openGraphDescription: data.open_graph_description,
  openGraphImageUrl: getCloudinarySourceUrl(data.open_graph_image),
  openGraphTitle: data.open_graph_title,
  robots: data.meta_robots,
  title: data.meta_title,
  jsonLdData: contentstackJsonLdListToJsonLdData(data.json_ld)
}));